var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.854 23.146l-9.009-9.009c1.336-1.502 2.155-3.473 2.155-5.637 0-4.687-3.813-8.5-8.5-8.5s-8.5 3.813-8.5 8.5 3.813 8.5 8.5 8.5c2.164 0 4.135-.819 5.637-2.156l9.009 9.009c.098.098.226.147.354.147s.256-.049.354-.146c.195-.196.195-.512 0-.708zm-22.854-14.646c0-4.136 3.364-7.5 7.5-7.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5-7.5-3.364-7.5-7.5z"}));
}

Search.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
